<div class="grid">
    <div class="column1">
        <ul class="list-results">
            <h2>Blog Posts</h2>
            <li>
                <div *ngIf="!blogService.keepFocus">
                    <button (click)="addBlogPost()">+ Add New Blog Post</button>
                </div>
            </li>

            <li *ngFor="let blogPost of allBlogPosts | async">
                <div *ngIf="blogPost == blogService.selectedBlogPost; else notSelected">
                    <span class="selected post-list" (click)="selectBlogPost(blogPost)">{{blogPost.title}}</span>
                </div>
                <ng-template #notSelected>
                    <div *ngIf="!blogService.keepFocus">
                        <button class="post-list" (click)="selectBlogPost(blogPost)">{{blogPost.title}}</button>
                    </div>
                </ng-template>
            </li>
        </ul>
    </div>

    <div class="seperator-line"></div>

    <div class="column2">
        <ng-container *ngIf="blogService.selectedBlogPost">
            <app-selected-blog-post [selectedBlogPost]="blogService.selectedBlogPost"> </app-selected-blog-post>
        </ng-container>
        <ng-container *ngIf="blogService.addingNewBlogPost">
            <app-new-blog-post></app-new-blog-post>
        </ng-container>
    </div>
</div>